var map = {
	"./hp_default.json": [
		71857,
		1857
	],
	"./hp_french.json": [
		60603,
		603
	],
	"./hp_german.json": [
		18791,
		8791
	],
	"./hp_spanish.json": [
		92443,
		2443
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 70588;
module.exports = webpackAsyncContext;